'use client';

import { forwardRef, useContext } from 'react';

import { css, cx } from '@/styled-system/css';

import { PropertyCardRootContext } from './context/property-card-root.context';
import { propertyCardActionAreaRecipe } from './styles/property-card-action-area.styles';
import type { PropertyCardActionAreaPropsInterface } from './types/property-card-action-area.types';

/**
 * A container for action buttons in a `PropertyCard`.
 *
 * @since 8.63.0
 */
export const PropertyCardActionArea = forwardRef<
  HTMLDivElement,
  PropertyCardActionAreaPropsInterface
>((props: PropertyCardActionAreaPropsInterface, forwardedRef) => {
  const { appearance } = useContext(PropertyCardRootContext);
  const { children, className, css: cssProp, ...rest } = props;

  const styles = css(propertyCardActionAreaRecipe.raw({ appearance }), cssProp);

  return (
    <div
      ref={forwardedRef}
      data-c11n-component="PropertyCard.ActionArea"
      data-c11n-version={__C11N_VERSION__}
      className={cx('c11n', 'c11n_property-card__action-area', styles, className)}
      {...rest}
    >
      {children}
    </div>
  );
});

PropertyCardActionArea.displayName = 'PropertyCard.ActionArea';
